import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ActuatorRestService } from '@base/modules/rest/actuator/actuator-rest.service';
import { AuthenticationRestService } from '@base/modules/rest/authentication/authentication-rest.service';
import { CustomHttpInterceptor } from '@base/modules/rest/custom-http-interceptor';
import { BbsObjectRestService } from '@base/modules/rest/bbs-object/bbs-object-rest.service';
import { McmWizardRestService } from '@base/modules/rest/mcm-wizard/mcm-wizard-rest.service';
import { RegistrationRestService } from '@base/modules/rest/registration/registration-rest.service';
import { SmartReportRestService } from '@base/modules/rest/smart-reports/smart-report-rest.service';
import { UserRestService } from '@base/modules/rest/user/user-rest.service';
import { CustomFieldRestService } from '@base/modules/rest/custom-field/custom-field-rest.service';
import { LicenseRestAdapterService } from '@base/modules/rest/license/license-rest-adapter.service';
import { McmWizardRestAdapterService } from '@base/modules/rest/mcm-wizard/mcm-wizard-rest-adapter.service';
import { CustomFieldRestAdapterService } from '@base/modules/rest/custom-field/custom-field-rest-adapter.service';
import {
  UserOnlineActivityRestAdapterService
} from '@base/modules/rest/user/user-online-activity-rest-adapter.service';
import {
  OrganizationDiagramRestAdapterService
} from '@base/modules/rest/organization/organization-diagram-rest-adapter.service';
import { ObjectAttachmentRestService } from '@base/modules/rest/object-attachment/object-attachment-rest.service';
import { PrintTemplateRestService } from '@base/modules/rest/print-template/print-template-rest.service';
import { SmartReportTemplateRestService } from '@base/modules/rest/smart-reports/smart-report-template-rest.service';
import {
  LpfrInstallationRestService
} from '@views/secured/beyond-retail/modules/rest/lpfr/service/lpfr-installation-rest.service';
import { FileRestUtilsService } from './common/file-rest-utils.service';
import { BeyondSuiteRestService } from './authentication/beyondsuite-rest.service';
import { UserOnlineActivityRestService } from './user/user-online-activity-rest.service';
import { PriceListRestService } from './price-list/price-list-rest.service';
import { ObjectRestServiceCreator } from './object/object-rest-service-creator';
import { PopisExportRestService } from './popis-export/popis-export-rest.service';
import { ParametersRestService } from './parameters/parameters-rest.service';
import { HistoryRestService } from './master-data-history/history-rest.service';
import { CacheRestService } from './cache/cache-rest.service';
import { EmployeeRewardsRestService } from './employee-rewards/employee-rewards-rest.service';
import { EmployeeGoalsRestService } from './employee-goals/employee-goals-rest.service';
import { OcenjivanjeRadnikaRestService } from './ocenjivanje-radnika/ocenjivanje-radnika-rest.service';
import { SendingReportRestService } from './smart-reports/sending-report-rest.service';

@NgModule({
  imports: [
    HttpClientModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    FileRestUtilsService,
    AuthenticationRestService,
    BeyondSuiteRestService,
    RegistrationRestService,
    UserRestService,
    ActuatorRestService,
    SmartReportRestService,
    SendingReportRestService,
    SmartReportTemplateRestService,
    BbsObjectRestService,
    McmWizardRestService,
    CustomFieldRestService,
    UserOnlineActivityRestService,
    PriceListRestService,
    ObjectRestServiceCreator,
    McmWizardRestAdapterService,
    CustomFieldRestAdapterService,
    LicenseRestAdapterService,
    UserOnlineActivityRestAdapterService,
    OrganizationDiagramRestAdapterService,
    ObjectAttachmentRestService,
    PrintTemplateRestService,
    PopisExportRestService,
    HistoryRestService,
    ParametersRestService,
    CacheRestService,
    LpfrInstallationRestService,
    EmployeeRewardsRestService,
    EmployeeGoalsRestService,
    OcenjivanjeRadnikaRestService,
  ],
})
export class RestModule {
}
